import axios from "axios";

// const
const ALGORITHM_LIST_UPDATE_DATA = "algorithmList/ALGORITHM_LIST_UPDATE_DATA";
const ALGORITHM_LIST_STORE_ALGORITHMS = "algorithmList/ALGORITHM_LIST_STORE_ALGORITHMS";
const ALGORITHM_LIST_TOGGLE_MODAL = "algorithmList/ALGORITHM_LIST_TOGGLE_MODAL";
const ALGORITHM_LIST_TOGGLE_LOADING = "algorithmList/ALGORITHM_LIST_TOGGLE_LOADING";

const ALGORITHM_LIST_MODAL_SUCCESS_TITLE = "scenes_Algorithm_AlgorithmList_modal_success_title";
const ALGORITHM_LIST_MODAL_FAIL_TITLE = "scenes_Algorithm_AlgorithmList_modal_fail_title";
const ALGORITHM_LIST_MODAL_DELETE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmList_modal_deleteSuccess_content";
const ALGORITHM_LIST_MODAL_DELETE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmList_modal_deleteFail_content";
const ALGORITHM_LIST_MODAL_OFFLINE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmList_modal_offlineSuccess_content";
const ALGORITHM_LIST_MODAL_OFFLINE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmList_modal_offlineFail_content";
const ALGORITHM_LIST_MODAL_OK_LABEL = "scenes_Algorithm_AlgorithmList_modal_OK_label";
const ALGORITHM_LIST_MODAL_CANCEL_LABEL = "scenes_Algorithm_AlgorithmList_modal_cancel_label";

// reducer
export const algorithmList = (state = {

  loading: false,
  userId:"",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  algorithms: [],
  showAlgorithms: [],
  name: "",
  algorithmId: "",
  selectedKey: "",
  algorithmStatusCode: ""
}, action) => {
  switch (action.type) {
    case ALGORITHM_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_LIST_STORE_ALGORITHMS:
      return {
        ...state,
        algorithms: action.data,
        showAlgorithms: action.data,
        selectedKey: "",
        algorithmStatusCode: ""
      };
    case ALGORITHM_LIST_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case ALGORITHM_LIST_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateAlgorithmListData = (data) => {
  return {
    type: ALGORITHM_LIST_UPDATE_DATA,
    data: data
  }
};


/**
 * get all app types
 */
export const getAlgorithms = (userId) => (dispatch) => {
  dispatch(toggleLoading(true));
  console.log("userId",userId)
  axios.get(`/api-algorithm/getAlgorithmsByUserId/${userId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        console.log("Algorithms",response.data)
        dispatch(storeAlgorithms(response.data));
        dispatch(updateAlgorithmListData({
          name: "userId",
          value: userId
        }));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all app algorithms
 */
export const storeAlgorithms = (algorithms) => {
  return {
    type: ALGORITHM_LIST_STORE_ALGORITHMS,
    data: algorithms
  }
};

/**
 * filter algorithm
 */
export const filterAlgorithm = (data) => (dispatch) => {
  let showAlgorithms = data.algorithms.filter(algorithm => {
    return algorithm.name.indexOf(data.name) > -1
  });
  dispatch(updateAlgorithmListData({
    name: "showAlgorithms",
    value: showAlgorithms
  }));
  dispatch(updateAlgorithmListData({
    name: "selectedKey",
    value: ""
  }));
  dispatch(updateAlgorithmListData({
    name: "algorithmStatusCode",
    value: ""
  }));
};

/**
 * delete algorithm
 */
export const deleteAlgorithm = (data) => (dispatch) => {

  let array = data.ids ? data.ids : [data.id];
  axios({
    method: "PUT",
    url: "/api-algorithm/deleteAlgorithm",
    contentType: "application/json",
    withCredentials: true,
    data: array
  }).then(
    response => {
      if (response.status === 200) {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_LIST_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_LIST_MODAL_DELETE_SUCCESS_CONTENT,
          modalOk: ALGORITHM_LIST_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getAlgorithms());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getAlgorithms());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        console.log("success delete algorithm");
      } else {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_LIST_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_LIST_MODAL_DELETE_FAIL_CONTENT,
          modalOk: ALGORITHM_LIST_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        console.log("fail to delete algorithm");
      }
    }
  );
};
/**
 * offline algorithm
 */
export const offlineAlgorithm = (data) => (dispatch) => {

  let array = data.ids ? data.ids : [data.id];
  axios({
    method: "PUT",
    url: "/api-algorithm/offlineAlgorithm",
    contentType: "application/json",
    withCredentials: true,
    data: array
  }).then(
    response => {
      if (response.status === 200) {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_LIST_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_LIST_MODAL_OFFLINE_SUCCESS_CONTENT,
          modalOk: ALGORITHM_LIST_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getAlgorithms());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getAlgorithms());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        console.log("success offline algorithm");
      } else {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_LIST_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_LIST_MODAL_OFFLINE_FAIL_CONTENT,
          modalOk: ALGORITHM_LIST_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        console.log("fail to offline algorithm");
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: ALGORITHM_LIST_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_LIST_TOGGLE_LOADING,
    data: show
  }
};
